module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-03.9a71211c.svg";